export default "__VITE_ASSET__46ca53fa__"